import { render, staticRenderFns } from "./beneficiary_information.vue?vue&type=template&id=a16b18d8&"
import script from "./beneficiary_information.vue?vue&type=script&lang=js&"
export * from "./beneficiary_information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports